import React, { useState } from 'react';
import AuthModal from './AuthModal';
import '../styles/LandingPage.css';

function LandingPage() {
  const [showAuthModal, setShowAuthModal] = useState(false);

  return (
    <div className="landing-page">
      <div className="hero-section">
        <div className="hero-background"></div>
        <div className="hero-content">
          <img 
            src="/flair-ac-small.svg" 
            alt="Flair AC Logo" 
            className="hero-logo"
          />
          <h1 className="hero-title">
            Welcome to Flair Portal
          </h1>
          <p className="hero-subtitle">
            Your central hub for project management and team collaboration
          </p>
          <button
            className="cta-button"
            onClick={() => setShowAuthModal(true)}
          >
            Get Started
          </button>
        </div>
        </div>

      <div className="features-section">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Project Management</h3>
            <p>Track and manage your projects efficiently with our intuitive tools</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⏰</div>
            <h3>Time Tracking</h3>
            <p>Monitor working hours and project timelines with ease</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">👥</div>
            <h3>Team Collaboration</h3>
            <p>Work seamlessly with your team members and subcontractors</p>
          </div>
        </div>
      </div>

      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)} 
      />
    </div>
  );
}

export default LandingPage; 